(function (app, ng) {

    app.config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state("Transaction.Determine.Inforce",
            {
                url: "/Inforce",
                component: "inforce",
                resolve: {
                    transaction: ["transactionApi", "$transition$", function (transactionApi, $transition$) {
                        return transactionApi.get($transition$.params().transactionId);
                    }],
                    inforce: ["transaction", "inforceTransactionApi", function (transaction, inforceTransactionApi) {
                        return inforceTransactionApi.get(transaction.Id).catch(ng.noop);
                    }],
                    carriers: ["carrierApi", function (carrierApi) {
                        return carrierApi.getCarriers();
                    }],
                    products: ["productApi", function (productApi) {
                        return productApi.getActiveProducts();
                    }],
                    taxQualifications: ["taxQualifications", function (taxQualifications) {
                        return taxQualifications;
                    }],
                    lineOfBusinessCategories: ["lineOfBusinessCategoryApi", function (lineOfBusinessCategoryApi) {
                        return lineOfBusinessCategoryApi.getCategories();
                    }]
                },
                onEnter: ["transaction", "transactionApi", function (transaction, transactionApi) {
                    transaction.LastTransactionStage = "Inforce";
                    transactionApi.updateLastTransactionStage(transaction.Id, transaction);
                }]
            });
    }]);

    app.component("inforce",
        {
            templateUrl: "/App/Transaction/Determine/Inforce/template.html",
            controller: inforceController,
            bindings: {
                transaction: "<",
                carriers: "<",
                products: "<",
                taxQualifications: "<",
                lineOfBusinessCategories: "<",
                inforce: "<"
            }
        });

    inforceController.$inject = ["$state", "$scope", "_", "inforceTransactionApi"];
    function inforceController($state, $scope, _, inforceTransactionApi) {
        $scope.$parent.$ctrl.getCurrentStage($state);
        var $ctrl = this;

        ng.extend($ctrl,
            {
                filterProducts: filterProducts,
                getProductType: getProductType,
                next: next,
                product: {}
            });

        function filterProducts(product) {
            if ($ctrl.inforce && $ctrl.inforce.CarrierId) {
                if (product.Id === 'Not Listed' || product.Carrier.Id === $ctrl.inforce.CarrierId) {
                    return true;
                } else {
                    return false;
                }
            }
            return true;
        }
        function getProductType(selection) {
            var product = _.find($ctrl.products, function (item) { return item.Id === selection });
            if (product) {
                $ctrl.product = product;
            } else {
                $ctrl.unlistedProduct = true;
            }
        };

        function next() {
            if ($ctrl.inforce.CarrierId === "Not Listed") {
                $ctrl.inforce.CarrierId = null;
                $ctrl.inforce.ProductId = null;
            } else {
                $ctrl.inforce.CarrierName = null;
            }

            if ($ctrl.inforce.ProductId !== null && $ctrl.inforce.ProductId !== 'Not Listed') {
                $ctrl.inforce.ProductName = null;
            }

            if ($ctrl.correctType && $ctrl.inforce.ProductId !== 'Not Listed') {
                $ctrl.inforce.LineOfBusinessId = $ctrl.product.LineOfBusinessCategory.LineOfBusiness.Id;
            }

            if ($ctrl.inforce.TaxQualification !== "Other") {
                $ctrl.inforce.OtherTaxQualification = "";
            }

            if ($ctrl.inforce.ProductId === 'Not Listed') {
                $ctrl.inforce.ProductId = null;
            }

            if ($ctrl.inforce.LineOfBusinessId === 'Not Listed') {
                $ctrl.inforce.LineOfBusinessId = null;
            } else {
                $ctrl.inforce.LineOfBusinessName = null;
            }

            if ($ctrl.inforce.Id) {
                return inforceTransactionApi.update($ctrl.inforce).then(function () {
                    if ($ctrl.transaction.DeterminePoints.includes("DetermineDocuments"))
                        $state.go("Transaction.Determine.Documents", { transactionId: $ctrl.transaction.Id });
                    else
                        $state.go("Transaction.Application.InforceApplication", { transactionId: $ctrl.transaction.Id });
                    // $state.go("Transaction.Application.FormsPipeline", { transactionId: $ctrl.transaction.Id });
                });
            } else {
                $ctrl.inforce.TransactionId = $ctrl.transaction.Id;
                return inforceTransactionApi.add($ctrl.inforce).then(function () {
                    if ($ctrl.transaction.DeterminePoints.includes("DetermineDocuments"))
                        $state.go("Transaction.Determine.Documents", { transactionId: $ctrl.transaction.Id });
                    else
                        $state.go("Transaction.Application.InforceApplication", { transactionId: $ctrl.transaction.Id });
                        // $state.go("Transaction.Application.FormsPipeline", { transactionId: $ctrl.transaction.Id });
                });
            }
        }

        this.$onInit = function() {
            $ctrl.carriers.push({ Id: "Not Listed", Business: { Name: "Not Listed" } });
            $ctrl.products.push({ Id: "Not Listed", Name: "Not Listed" });
            $ctrl.lineOfBusinessCategories.push({ Id: "Not Listed", LineOfBusiness: { Name: "Not Listed", Id: "Not Listed" } });

            if ($ctrl.inforce) {
                if ($ctrl.inforce.ProductId) {
                    $ctrl.product = _.find($ctrl.products, function (item) { return item.Id === $ctrl.inforce.ProductId });

                    if ($ctrl.product.LineOfBusinessCategory.LineOfBusiness.Id === $ctrl.inforce.LineOfBusinessId) {
                        $ctrl.correctType = "true";
                    } else {
                        $ctrl.correctType = "false";
                    }
                }

                if ($ctrl.inforce.CarrierName) {
                    $ctrl.inforce.CarrierId = "Not Listed";
                }

                if ($ctrl.inforce.ProductName) {
                    $ctrl.inforce.ProductId = "Not Listed";
                }

                if ($ctrl.inforce.LineOfBusinessName) {
                    $ctrl.inforce.LineOfBusinessId = "Not Listed";
                }
            }
        };
    }

})(window.app, window.angular);